import React, { useState } from "react";
import { Button, Grid, TextField, Box, Checkbox } from "@material-ui/core";
const VariationsSelection = ({
  closeKapDailog,
  getVariations,
  logicalName,
}) => {
  const [count, setCount] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [emptyErr, setEmptyErr] = useState(false);
  const [invalidEntry, setInvalidEntry] = useState(false);
  const addEnteredKap = () => {
    if (selectAll) getVariations("all", logicalName);
    else if (!selectAll && count && count.trim() !== "") {
      if (count === '0') setInvalidEntry(true)
      else getVariations(count, logicalName);
    }
    else setEmptyErr(true);
  };
  return (
    <div>
      <Grid container spacing={3}>
        <h6>
          NOTE: Please select any one option to set the count of scenario
          variation records.
        </h6>
        <Grid item sm={12}>
          <Box display="flex" justifyContent="flex-start">
            <Checkbox
              checked={selectAll}
              color="primary"
              style={{ marginLeft: "-9px" }}
              onChange={(event) => {
                emptyErr && setEmptyErr(false);
                invalidEntry && setInvalidEntry(true);
                count.trim() && setCount("");
                setSelectAll(event.target.checked);
              }}
              inputProps={{ "aria-label": "variation-count" }}
            />
            <span style={{ marginTop: "8px" }}>Select All Variations</span>
          </Box>
        </Grid>
        <h6 style={{ margin: "0 1rem" }}>
          <b>OR</b>
        </h6>
        <Grid item sm={12}>
          <TextField
            required
            variant="outlined"
            id="variation-count"
            label="Variation Count"
            value={count}
            onChange={(e) => {
              invalidEntry && setInvalidEntry(true);
              selectAll && setSelectAll(false);
              emptyErr && setEmptyErr(false);
              setCount(e.target.value);
            }}
            fullWidth
            margin="normal"
          />
          {invalidEntry && <span style={{ color: "#d32f2f" }}>
            Count should be greater than 0 *
          </span>}
        </Grid>
        <Grid item sm={12} sx={{ mt: -4 }}>
          {emptyErr && (
            <span style={{ color: "#d32f2f" }}>
              Atlease one option needs to be filled *
            </span>
          )}
        </Grid>
        <Grid item sm={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              onClick={closeKapDailog}
              variant="outlined"
              style={{ marginRight: "1rem" }}
            >
              Close
            </Button>
            <Button
              onClick={addEnteredKap}
              variant="outlined"
              style={{
                backgroundColor: "#622AD8",
                color: "white",
                "&:hover": {
                  backgroundColor: "#303f9f",
                },
              }}
            >
              Proceed
            </Button>
          </Box>
        </Grid>
        {/* <Grid item sm={6}>
        </Grid> */}
      </Grid>
    </div>
  );
};
export default VariationsSelection;
